// extracted by mini-css-extract-plugin
export default {"emailMessage":"ApplicantMindsightMessageTimeline_emailMessage__hO-f1"};